export const Theme = {
    body: 'white',
    text: 'var(--gray-900)',
    tag: '#0C0C0C',
    tagtext: 'white',
    toggleBorder: 'var(--gray-800)',
    background: '#FCFCFC',
    hover: 'var(--blue-900)',
    shadow: 'rgba(0, 0, 0, 0.40)',
    svg: 'var(--orange)',
    mobile: '1000px',
    footer: 'white',
    day: '#ffd376',
    ala: '#7bb0c0',
    matematica:'#8b82d0',
    estetic:'#856bb4',
    limbaj:'#ffaed4',
    socioEmotional:'#ffa75f',
    cunoastereaMediului:'#ffc600',
    dezvp:'#00a8f6',
    tranzitii:'#00c56b',

}